export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-ease/src/linear.js
// module id = +Vac
// module chunks = 0